<template>
  <div>
    <iframe
      :src="getWebPlayerURL()"
      width="100%"
      height="1000"
      frameborder="0"
    ></iframe>
  </div>
</template>

<script>
export default {
  methods: {
    getWebPlayerURL() {
      const projectFilePath =
        "https://static.smallschoolbag.com/static/noten/website/home/gif/choujiang.sb3";
      const webPlayerURL = "https://scratch.mit.edu/projects/embed";

      const url = new URL(webPlayerURL);
      url.searchParams.append("project", projectFilePath);

      return url.toString();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/home/apps/index.vue